/** Estoque a partir do qual o card exibe o selo "Ultimas unidades". */
export const LOW_STOCK_THRESHOLD = 5;

/** Placeholder usado quando o premio nao tem imagem ou ela falha ao carregar. */
export const PRODUCT_PLACEHOLDER = 'assets/images/image.svg';
